<template>
  <div v-if="landing && landing.settings && landing.settings.message">
    <div v-html="landing.settings.message"></div>
  </div>
</template>

<script>
import { error_message, get } from "@/utils";

export default {
  name: "LandingDefault",
  components: {},
  data() {
    return {
      landing: {},
    };
  },
  methods: {
    retrieve_landing() {
      let v = this;
      get("/landing", {})
        .then((response) => {
          v.landing = response;
        })
        .catch((error) => {
          console.log(error);
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.$emit("hide_nav");
    v.retrieve_landing();
  },
  created() {},
};
</script>

<style scoped></style>
